export class LiveChatError extends Error {
    constructor(message: any) {
        if (message instanceof Error || message instanceof LiveChatError) {
            super(message.message); // Extract the message if an Error is passed
        } else {
            super(message);
        }

        this.name = "LiveChatError";
        Object.setPrototypeOf(this, LiveChatError.prototype);
    }
}
